import React from "react";
import ReactJson from "react-json-view";

export default ({ user }) => {
  return (
    <div>
      <div className="p-2">
        <ReactJson
          src={user}
          theme="monokai"
          style={{
            borderRadius: "0.25rem",
            padding: "0.5rem",
          }}
          displayDataTypes={false}
          enableClipboard={true}
        />
      </div>
    </div>
  );
};
